import React, { Component } from 'react';
import CalculatorForm from './Components/CalculatorForm/CalculatorForm';
import CalculatorOutput from './Components/CalculatorOutput/CalculatorOutput';
import { CSSTransition } from 'react-transition-group';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dogName: null,
      dogSize: null,
      dogYears: null,
      dogMonths: null,
      showAnswer: false
    }
  }

  formDataHandler = (formData) => {

    this.setState({
      showAnswer: formData.isValid,
      dogName: formData.dogName,
      dogSize: formData.dogSize,
      dogYears: formData.dogYears,
      dogMonths: formData.dogMonths
    });
  }

  render() {
    return (
      <div className="dog-age-calculator-wrapper">
        <CalculatorForm
          formDataHandler={this.formDataHandler}
        />
        {
          this.state.showAnswer ?
            <CSSTransition
              in={true}
              timeout={300}
              classNames="example"
              unmountOnExit
              onEnter={() => null}
              onExited={() => null}
            >
              <CalculatorOutput formData={this.state} />
            </CSSTransition> : null
        }
      </div >
    );
  }
}

export default App;
